module.exports = __webpack_public_path__ + "static/media/help_is_just_around_the_corner.b1c9366e.png";